import React from 'react';
import linkbridgeLogo from './IMG/LinkBridge.png';
import userLogo from './IMG/User.png';
import rajsnehagroLogo from './IMG/RajSnehAgro.png';

function Header({ currentUser }) {
  // Determine which logo to show for the user
  let userCompanyLogo = userLogo;
  // if (currentUser && currentUser.company === 'Raj Sneh Agro Foods Private Limited') {
  //   userCompanyLogo = rajsnehagroLogo;
  // }

  return (
    <header style={{ background: '#14e460a5', color: '#fff', padding: '0px 20px', height: '110px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={linkbridgeLogo} alt="LinkBridge Logo" style={{ height: '90px', marginRight: '24px' }} />
        <div>
          {/* <h1 style={{ padding: '0', margin: '0' }}>LinkBridge</h1> */}
          <span style={{ fontSize: '1.2rem', color: '#333', marginLeft: '4px' }}>Weighbridge Database Management</span>
        </div>
      </div>
      {/* User details and logo (right side) */}
      {currentUser && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={userCompanyLogo} alt="User Logo" style={{ height: '48px', borderRadius: '50%', background: '#fff', padding: '2px' }} />
          <span style={{ color: '#222', fontWeight: 500, fontSize: '1.1rem' }}>{currentUser.name || currentUser.username}</span>
        </div>
      )}
    </header>
  );
}

export default Header;
